import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import iconBackArrow from "../../assets/icons/back-arrow-filled.svg";

import { AnimationData } from "../../assets/glb/animations";
import { getAnimationByTokens } from "../../utils/animationHandle";
import { validateEmail } from "../../utils/regex";
import LibrasIcon from "../../assets/icons/libras-icon.svg";
import { LibrasButtonMenu } from "../LibrasButtonMenu";
import {
  InputEmailMenuContainer,
  ConfirmButton,
  Container,
  CancelButton
} from "./styles";

interface EmailInputComponentsProps {
  setAnimation?: React.Dispatch<React.SetStateAction<AnimationData[]>>;
  setSocketResponse?: React.Dispatch<React.SetStateAction<boolean>>;
  onBack: () => void;
  scenarioName?: string;
  scenarioId: number; 
}

export function EmailInput({
  setAnimation,
  setSocketResponse,
  scenarioName,
  onBack,
  scenarioId
}: EmailInputComponentsProps) {
  const [email, setEmail] = useState("");
  const [validEmail, setValidEmail] = useState<boolean>(false);
  const [emailError, setEmailError] = useState<boolean>(false);
  const [emailSended, setEmailSended] = useState(false);
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState <boolean>(false);
  const [loadingLibrasKey, setLoadingLibrasKey] = useState<"intro" | "sent" | null>(null);


  function changeEmail() {
    setValidEmail(false);
    setEmailError(false);
  }

  function playLibrasWithLoading(key: "intro" | "sent", glosaText: string) {
    setLoadingLibrasKey(key);

    const handleStarted = () => {
      setLoadingLibrasKey(null);
      window.removeEventListener("LISA_ANIMATION_STARTED", handleStarted);
    };

    window.addEventListener("LISA_ANIMATION_STARTED", handleStarted, { once: true });

    window.dispatchEvent(new CustomEvent("LISA_INTERRUPT"));

    getAnimationByTokens(glosaText)
      .then((animations) => {
        if (setAnimation) {
          setAnimation(animations);
          window.dispatchEvent(new CustomEvent("LISA_RESUME"));
        }
      })
      .finally(() => {
        setLoadingLibrasKey(null);
      });
  }


  function chatScroll() {
    const msgBody = document.getElementById("content");
    if (msgBody) {
      setTimeout(() => {
        msgBody.scroll({
          top: 50000000,
          behavior: "smooth"
        });
      }, 600);
    }
  }

  function confirm() {
    if (!validateEmail.test(email)) {
      setEmailError(true);
      setValidEmail(false);
      if (setSocketResponse) setSocketResponse(false);
    } else {
        setValidEmail(true);
        setEmailError(false);
        if (setSocketResponse) setSocketResponse(false);
        sendEmail();
      // });
    }
  }

  async function sendEmail(): Promise<void> {
    try {
      const path = process.env.REACT_APP_API_URL;

      const options = {
        method: "POST",
        url: `${path}/scenario/mail/send`, 
        headers: {
          "Content-Type": "application/json",
        },
        data: { 
          email: email,
          scenario_id: scenarioId + ""
        }
      };

      return axios
        .create({withCredentials: true})
        .request(options)
        .then((response) => {
          setEmailSended(true);
        });
    } catch (error) {
      console.error("Erro ao enviar email:", error);
    }
  }

  useEffect (()=> {
    const checkScreen =()=> {
      setIsMobile(window.innerWidth <677 )
    }
    checkScreen();
    window.addEventListener('resize',checkScreen)
    return ()=> window.removeEventListener('resize',checkScreen)  
  },[])

  function handleBack(){
    onBack();
  }

  return (
    <Container>
      {!isMobile && (
      <div className="EmailInputHeader">
        <img onClick={handleBack} className="hint" data-hint="Voltar" data-hint-placement="bottom" src={iconBackArrow} alt="voltar" />
        <span>{scenarioName} / <u>Enviar por e-mail</u></span>
      </div>
      )}
      {!emailSended ? (
        <InputEmailMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Receber instruções por email</span>
              <LibrasButtonMenu
                disabled={loadingLibrasKey === "intro"}
                onClick={() =>
                  playLibrasWithLoading(
                    "intro",
                    "VOCE RECEBER INFORMACOES DIGITAR EMAIL CERTO SINAL_ARROBA D E L L SINAL_PONTO C O M OU SINAL_ARROBA D E L L T E A M SINAL_PONTO C O M VAI EMAIL INFORMACOES"
                  )
                }
              >
                {loadingLibrasKey === "intro" ? (
                  <span className="btnSpinner" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
              </LibrasButtonMenu>

            </div>
            { (!isMobile || !emailError) &&
            <span className="sub">
              Digite um email válido que termine com <b>@dell.com</b> ou{" "}
              <b>@dellteam.com</b>.
            </span>}
            {
              (emailError && isMobile) &&
              <span style={{ color: "red"}}>
                "Insira um email válido, que termine com @dell.com ou @dellteam.com, para receber o relatório."
              </span>
            }
          </div>

          <div className="sendEmailContainer">
            <div className="inputContainer">
              <input
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                type="email"
                id="email"
                placeholder="Ex: colaborador@dell.com ou colaborador@dellteam.com"
              />
            </div>
          </div>

          <div className="buttonContainer">
            <CancelButton type="button" onClick={onBack}>
              Cancelar
            </CancelButton>
            <ConfirmButton type="button" onClick={confirm}>
              Enviar
            </ConfirmButton>
          </div>

          {(emailError && !isMobile) && (
            <span style={{ color: "red", marginTop: "10px" }}>
              Insira um email válido, que termine com @dell.com ou @dellteam.com, para receber o relatório.
            </span>
          )}
        </InputEmailMenuContainer>
      ) : (
        <InputEmailMenuContainer>
          <div className="titleContainer">
            <div className="title">
              <span>Enviado!</span>
              <LibrasButtonMenu
                disabled={loadingLibrasKey === "sent"}
                onClick={() =>
                  playLibrasWithLoading(
                    "sent",
                    "JA ENVIAR VER SEU EMAIL"
                  )
                }
              >
                {loadingLibrasKey === "sent" ? (
                  <span className="btnSpinner" />
                ) : (
                  <img src={LibrasIcon} alt="Ícone Libras" />
                )}
            </LibrasButtonMenu>

            </div>
            <span className="sub">
              Verifique sua caixa de entrada.
            </span>
          </div>
        </InputEmailMenuContainer>
      )}
    </Container>
  );
}
